import { Input } from "@repo/core/components/core/Input";
import { Controller } from "react-hook-form";

import { InputControlledProps } from "./types";

export const InputControlled = ({
  name,
  control,
  defaultValue,
  onChange,
  onBlur: onInputBlur,
  transformValue,
  ...props
}: InputControlledProps) => {
  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({
        field: { onChange: onChangeField, value, onBlur: onBlurField },
        fieldState: { error }
      }) => {
        return (
          <Input
            {...props}
            isInvalid={!!error?.message}
            errorMessage={error?.message || ""}
            onChange={(val) => {
              onChangeField(val);
              onChange?.(val);
            }}
            onBlur={(event) => {
              onBlurField();
              onInputBlur?.(event);
            }}
            value={value}
            name={name}
            transformValue={transformValue}
          />
        );
      }}
    />
  );
};
